import React, { FC } from 'react'
import { Flex, Text, theme, Button, Spinner } from '@gassan-ui'
import { useLocalization } from '@components/Localization'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { motion } from 'framer-motion'
import styled from 'styled-components'

const Parent = styled(motion.custom(Flex))``

type Props = {
  price: string
  status: 'updating' | 'idle'
}

const StickySummary: FC<Props> = ({ price, status }) => {
  const { lang } = useLocalization()

  return (
    <Parent
      justifyContent="space-between"
      alignItems="center"
      position="fixed"
      background="white"
      zIndex={theme.zIndices.quickCart}
      left="0"
      width="100%"
      bottom="env(safe-area-inset-bottom)"
      p={['0.5rem 1rem', '0.75rem 2rem']}
      borderTop={`1px solid ${theme.colors.shades[200]}`}
      boxShadow="0px -2px 15px rgba(0, 0, 0, 0.07)"
      style={{ transform: ' translateZ(0)' }}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 40 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <Flex flexDirection="column">
        <Text variant="micro" color="shades.500" mb="0.25rem" as="span">
          {lang === 'nl' ? 'Totaal' : 'Total'}
        </Text>
        {status === 'idle' ? (
          <Text variant="large" mb="0" as="span">
            {price}
          </Text>
        ) : (
          <Flex alignItems="center" color="tabaccoBrown" height="1.5rem">
            <Spinner size="1rem" />
          </Flex>
        )}
      </Flex>
      <LocalizedLink href="/[...slug]" as="/checkout">
        <Button variant="dark" status={status === 'updating' ? 'disabled' : 'idle'} as="link">
          {lang === 'nl' ? 'Afrekenen' : 'Order'}
        </Button>
      </LocalizedLink>
    </Parent>
  )
}

export default StickySummary
